import { render, staticRenderFns } from "./RatingTable.vue?vue&type=template&id=63d73db3&"
import script from "./RatingTable.vue?vue&type=script&lang=js&"
export * from "./RatingTable.vue?vue&type=script&lang=js&"
import style0 from "./RatingTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports